import { InjectionToken } from '@angular/core';

/**
 * Optional injection token for the asset version segment used in versioned asset URLs.
 * Provide a unique version identifier such as a git commit SHA (e.g. `'abc1234'`)
 * to enable immutable cache headers for AngularKit assets. A trailing slash is not
 * required — NgKitAssetUrlService normalises it automatically.
 * When not provided, asset URLs are unversioned. Consumed by NgKitAssetUrlService.
 * @example
 * // In your app providers:
 * { provide: NGKIT_ASSET_VERSION, useValue: versionId }
 */
export const NGKIT_ASSET_VERSION = new InjectionToken<string>('ngkit-asset-version');
